module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/993ac0915457fb00edd1d4ee92ba9a08.png";